import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface PageHeaderProps {
  icon: React.ReactNode;
  actionTitle: string;
  title: string;
  description: string;
  handleNew?: () => void;
  children?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  icon,
  actionTitle,
  title,
  description,
  handleNew,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <div className="p-4 ">
      <div className="flex justify-between items-end">
        <div className="flex flex-col space-y-2">
          {/* <Users className="w-16 h-16 text-primary-foreground" /> */}
          <div className="flex items-center space-x-4">
            {icon}
            <h1 className="text-3xl font-bold text-primary-foreground">
              {t(title)}
            </h1>
          </div>
          <p className="text-sm text-primary-foreground">{t(description)}</p>
        </div>
        <div className="flex space-x-2">
          {children}
          {actionTitle && actionTitle !== "" && (
            <Button
              variant="default"
              className="bg-primary text-primary-foreground hover:bg-primary-foreground/50 hover:text-primary-foreground"
              onClick={handleNew}
            >
              {t(actionTitle)}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
